export default __webpack_public_path__ + "static/media/360-factory-visibility.a1545959.svg";